module.exports = __webpack_public_path__ + "img/about5.3ba52fc9.jpg";